<template>
  <v-btn large dark :loading="loadingval" block>
    <p class="button-wrap"><slot></slot></p>
  </v-btn>
</template>

<script>
export default {
  props: {
    loadingval: {
      type: Boolean,
    },
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

button {
  max-width: 100%;
}
.button-wrap {
  white-space: pre-wrap;
}
.v-btn__content {
  max-width: 100%;
}
.v-application p {
  margin-bottom: 0px;
}

@media only screen and (max-width: 477px) {
  .button-wrap {
    font-size: 10px;
  }
}
</style>
